// React
import React from 'react';
import ReactDOM from 'react-dom';

// Redux
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';

// // Redux Persist
// import { persistStore, persistCombineReducers } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';

// React Router
import { Route } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';

// Material UI
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import theme from './muiTheme';

import { unregister } from './registerServiceWorker';

import App from './components/App';
import Api from './services/api';
import * as reducers from './redux';
import './index.css';

import { homepage } from '../package.json';

// React-Dates
import ThemedStyleSheet from 'react-with-styles/lib/ThemedStyleSheet';
import CSSInterface from 'react-with-styles-interface-css';
ThemedStyleSheet.registerInterface(CSSInterface);

// URLSearchParams Polyfill
if (!window.URLSearchParams) {
  const URLSearchParams = require('url-search-params');
  window.URLSearchParams = URLSearchParams;
}

// Array.prototype.find Polyfill
if (!Array.prototype.find) {
  const FindPolyfill = require('./utils/polyfills').FindPolyfill;
  FindPolyfill();
}

// Array.prototype.findIndex Polyfill
if (!Array.prototype.findIndex) {
  const FindIndexPolyfill = require('./utils/polyfills').FindIndexPolyfill;
  FindIndexPolyfill();
}

// Number.isNaN Polyfill
if (!Number.isNaN) {
  const IsNaNPolyfill = require('./utils/polyfills').IsNaNPolyfill;
  IsNaNPolyfill();
}

// String.includes Polyfill
if (!String.prototype.includes) {
  const StringIncludesPolyfill = require('./utils/polyfills')
    .StringIncludesPolyfill;
  StringIncludesPolyfill();
}

// Array.includes Polyfill
if (!Array.prototype.includes) {
  const ArrayIncludesPolyfill = require('./utils/polyfills')
    .ArrayIncludesPolyfill;
  ArrayIncludesPolyfill();
}

// Array.from Polyfill
if (!Array.prototype.from) {
  const FromPolyfill = require('./utils/polyfills').FromPolyfill;
  FromPolyfill();
}

if (typeof SVGElement.prototype.focus === 'undefined') {
  const SvgElementFocusWorkaround = require('./utils/polyfills')
    .SvgElementFocusWorkaround;
  SvgElementFocusWorkaround();
}

window.api = new Api();
let basename;

// App runs at the root locally, but under /observer in production
process.env.NODE_ENV !== 'production' ? (basename = '') : (basename = homepage);

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = combineReducers(reducers);

export const store = createStore(
  rootReducer,
  composeEnhancer(applyMiddleware(thunk))
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename={basename}>
      <MuiThemeProvider muiTheme={theme}>
        <Route path="/" component={App} />
      </MuiThemeProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js